import { render, staticRenderFns } from "./Spotlighting.vue?vue&type=template&id=073e8066&"
import script from "./Spotlighting.vue?vue&type=script&lang=ts&"
export * from "./Spotlighting.vue?vue&type=script&lang=ts&"
import style0 from "./Spotlighting.vue?vue&type=style&index=0&id=073e8066&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports